import React from 'react';
import { CONTROL_BUTTON, LABEL_STYLES } from '../../constants/styles';

interface DiceCountSelectorProps {
  dicePerPlayer: number;
  onDiceCountChange: (count: number) => void;
}

const DiceCountSelector: React.FC<DiceCountSelectorProps> = ({
  dicePerPlayer,
  onDiceCountChange,
}) => {
  const MIN_DICE = 1;
  const MAX_DICE = 10;

  const handleDecrease = () => {
    onDiceCountChange(Math.max(MIN_DICE, dicePerPlayer - 1));
  };

  const handleIncrease = () => {
    onDiceCountChange(Math.min(MAX_DICE, dicePerPlayer + 1));
  };

  return (
    <div className="flex items-center gap-2">
      <label className={`${LABEL_STYLES} flex-shrink-0`}>
        Dice:
      </label>
      <button
        onClick={handleDecrease}
        disabled={dicePerPlayer <= MIN_DICE}
        className={CONTROL_BUTTON}
        aria-label="Decrease dice count"
      >
        −
      </button>
      <div className="w-10 h-8 bg-surface-50 dark:bg-gray-700 rounded flex items-center justify-center border border-surface-300 dark:border-gray-600">
        <span className="text-lg font-bold text-gray-900 dark:text-white">{dicePerPlayer}</span>
      </div>
      <button
        onClick={handleIncrease}
        disabled={dicePerPlayer >= MAX_DICE}
        className={CONTROL_BUTTON}
        aria-label="Increase dice count"
      >
        +
      </button>
    </div>
  );
};

export default DiceCountSelector;